// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3yOWl","productName":"Table_productName__aPBcn"};